//privacy stuff mainpage
import React from 'react';
import ButtonLink from '../../components/Button';

const Privacy = () => {
  return (
    <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Privacy</h1>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          <div className="rule-card">
            <h2>Privacy statements</h2>
            <p>Read our privacy statements below:</p>
            <p className="documents-item">
                <ButtonLink href="privacy/Membership_privacy_policy" newTab="False">
                  Membership privacy policy
                </ButtonLink>
              </p>

              <p className="documents-item">
                <ButtonLink href="privacy/Events_privacy_policy" newTab="False">
                  Events privacy policy
                </ButtonLink>
              </p>
          </div>
        </div>
      </section>
      <section className="content-section">
        <div className="container">

          <div className="rule-card">
            <h2>Website cookie policy</h2>
            <p>We only use strictly necessary cookies on integralis.fi.</p>
            <p>We use Cloudflare for load balancing, rate-limiting and bot detection and cookies may be collected for the aforementioned purposes. Additionally, we 
              use jsDelivr for content delivery, which collects necessary information such as IP addresses and diagnostic data.</p>
            <p>We may link to external sites such as SharePoint, social media, or Kide.app. These sites use cookies in accordance with their own policies. </p>
            
          </div>

          


        </div>
      </section>


    </div>
  );
}
export default Privacy;

